import { ReportAssets, ReportPDFAsset, ReportPDFReponse } from 'queries/report/contract';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import PdfPageTitle from '../components/PageTitle/PdfPageTitle';
import { PdfAssetsList } from '../components/Asset/PdfAssetsList';
import { PdfAssetCaptions } from '../components/Asset/PdfAssetCaptions/PdfAssetCaptions';
import PdfCasesSummaryItens from '../components/Cases/PdfCasesSummaryItens';
import PdfCasesSummaryHeader from '../components/Cases/PdfCasesSummaryHeader';

type AssetProps = {
  data: ReportPDFReponse;
  date: string;
  category: string;
};
export const SecondPage = ({ data, date, category }: AssetProps) => {
  return (
    <PageWrapper
      assetName={data.name}
      category={category}
      assetDescription={data.description}
      date={date}
    >
      <PdfPageTitle pageNumber={2} />
      <PdfAssetCaptions />
      {PdfAssetsList({
        data: data,
        depth: 3,
        casesHeader: PdfCasesSummaryHeader,
        casesComponent: PdfCasesSummaryItens,
      })}
    </PageWrapper>
  );
};
